__turbopack_context__.v({
  "container": "lZKkLa_container",
  "outletInfo": "lZKkLa_outletInfo",
  "selected": "lZKkLa_selected",
});
